















import { Component, Vue, Prop } from 'vue-property-decorator';
import InjuryReportForm from '@/components/forms/InjuryReportForm.vue';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        InjuryReportForm
    }
})
export default class InjuryReportEdit extends Vue {
    public $refs!: {
        editform: InjuryReportForm
    };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.editform.updateForm();
            next();
    }
}
